<div class="LCS_pie-chart-container">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [labels]="chartOptions.labels"
    [dataLabels]="chartOptions.dataLabels"
    [title]="chartOptions.title"
    [fill]="chartOptions.fill"
    [states]="chartOptions.states"
    [plotOptions]="chartOptions.plotOptions"
    [stroke]="chartOptions.stroke"
    [theme]="chartOptions.theme"
    [legend]="chartOptions.legend"
    [colors]="chartOptions.colors"
    [dataLabels]="chartOptions.dataLabels"
    [responsive]="chartOptions.responsive"
  ></apx-chart>
</div>